import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useUpdateEffect } from '@moda/om';
import './VerticalSnapperFrame.scss';

export type VerticalSnapperFrame = {
  index: number;
  onEnter(index: number): void;
  onLeave(index: number): void;
  children?: React.ReactNode;
};

export const VerticalSnapperFrame: React.FC<VerticalSnapperFrame> = ({
  index,
  children,
  onEnter,
  onLeave
}) => {
  const [ref, inView] = useInView({ threshold: 0.5 });

  useUpdateEffect(() => {
    if (inView) {
      onEnter(index);
    } else {
      onLeave(index);
    }
  }, [inView, onEnter, onLeave, index]);

  return (
    <div ref={ref} className="VerticalSnapperFrame">
      {children}
    </div>
  );
};
